import { Component } from "react"
import { withPrefix } from "gatsby"

class Link extends Component {
  constructor(props) {
    super(props)
    this.state = { activeClass: "" }
  }

  componentDidMount() {
    if (this.props.to === window.location.pathname.replace(/\/?$/, "")) {
      this.setState({ activeClass: "active" })
    }
  }

  render() {
    return (
      <a href={withPrefix(this.props.to)} className={this.state.activeClass}>
        {this.props.children}
      </a>
    )
  }
}

export default Link
